// extracted by mini-css-extract-plugin
export default {"aboutTitle":"Volunteer_aboutTitle__luwB4","aboutTitleWrapper":"Volunteer_aboutTitleWrapper__fUUeG","emTitle":"Volunteer_emTitle__km3S8"};